// getRandomValues is available on HTTP origins where randomUUID is not.
export function createSceneChannel(cryptoSource = globalThis.crypto) {
  const bytes = new Uint8Array(16);
  cryptoSource.getRandomValues(bytes);
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
}
